import { Box, useStyleConfig } from "@chakra-ui/react";
function Card(props) {
  const { variant, children, className, ...rest } = props;
  const styles = useStyleConfig("Card", { variant });
  
  // Merge custom styles with the default styles
  const cardStyles = {
    ...styles,
    ...(className && { className })
  };

  return (
    <Box __css={cardStyles} {...rest}>
      {children}
    </Box>
  );
}

export default Card;
